// js/router

/* global Vue */
/* global VueRouter */

//Vue.use(VueRouter) дает ошибку в консоль vue-router уже установлен

var router = new VueRouter({
  root: 'account',
  'linkActiveClass': 'active',
  history: true,
  saveScrollPosition: true,
})

export default router



/** WEBPACK FOOTER **
 ** ./src/js/router.js
 **/